import React from 'react';
import {Button, Icon} from '@albert-io/atomic';
import type {ButtonColor} from '@albert-io/atomic/atoms/Button/Button.react';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';
import {graphing} from 'client/components/QuestionTypes/shared/TranslationSection';

const iconMap: Record<string, IconProp | undefined> = {
  'Add point': ['fas', 'circle'],
  'Add ray': ['fas', 'long-arrow-alt-right'],
  'Add line': ['fas', 'arrows-alt-h'],
  'Add segment': ['fas', 'horizontal-rule'],
  'Add polygon': ['fas', 'vector-square'],
  'Add parabola': ['fas', 'union'],
  'Add inequality': ['fas', 'greater-than'],
  'Add circle': ['far', 'circle']
};

interface ToolbarOption {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  key?: string;
}

interface Props {
  options: ToolbarOption[];
  instructions?: string;
}

const Toolbar = ({options, instructions}: Props) => (
  <div className='mb-x4'>
    {options.map(({label, onClick, key}) => {
      const icon = iconMap[label];
      let buttonColor: ButtonColor = 'secondary';
      if (['Cancel', 'Done editing', graphing.done, graphing.cancel].includes(label)) {
        buttonColor = 'primary';
      } else if (/^delete/i.test(label)) {
        buttonColor = 'negative';
      } else if (/^eliminar/i.test(label)) {
        buttonColor = 'negative';
      }
      return (
        <Button
          className='mr-x1 mb-x1'
          size='s'
          color={buttonColor}
          onClick={onClick}
          key={key ?? label}
        >
          {icon && (
            <>
              <Icon icon={icon} />
              &nbsp;&nbsp;
            </>
          )}
          {label}
        </Button>
      );
    })}
    <span aria-live='polite'>{instructions}</span>
  </div>
);

export const renderToolbar = (options: ToolbarOption[], instructions?: string) => {
  return <Toolbar options={options} instructions={instructions} />;
};

export default Toolbar;
